import React from 'react';

import Card from './Card';

import Foot from './Foot';

import galleanowinery from './images/galleanowinery.jpg'
import ttrpg_creator from './images/ttrpg_creator.jpg'
import wordle_solver from './images/wordle_solver.jpg'
import stem_practice from './images/stem_practice.jpg'

const projects = [
  { title: "Galleano Winery", text: "Boostrap redesigned mobile friendly business website", image: galleanowinery, link: "https://web.archive.org/web/20150817042649/http://www.galleanowinery.com/" },
  { title: "TTRPG Character Creator", text: "React and Django (REST) Mork Borg (TTRPG) character creator", image: ttrpg_creator, link: "/ttrpg-creator/" },
  { title: "Wordle Solver", text: "Pure HTML, CSS, and JS wordle solver", image: wordle_solver, link: "/worlde-solver/" },
  { title: "STEM Practice", text: "Pure HTML, CSS, and JS pre-algebra and chemistry games", image: stem_practice, link: "/stem-practice/" }
];  


const MobilePage  = () => {

    return (
        
        <div className='container pt-3'>
            <div className="row">
                <h1>Trevor Vandergrift</h1>
                <h2>IT Professional</h2>
                <hr />
                <p>I’ve spent years supporting systems and solving problems — now I’m focused on building web experiences. I bring technical expertise, a service mindset, and a drive to make things better!</p>
            </div>

            <div className="row mt-3">
            <h3>Projects</h3>
            {projects.map((project, idx) => (
                <div className="col-lg-6 mb-3 text-center" key={idx}>
                    <Card {...project} />
                </div>
            ))}
        </div>
        <Foot />
        </div>
    )
}

export default MobilePage;